import { useEffect } from 'react'
import { IconClapper } from '../icons'

const TEAM_COLORS = ['#e05c5c', '#5c9ee0', '#5ce08a', '#e0c05c', '#c05ce0', '#5ce0d8']

export default function PartyTeamSetup({ party, onTeamsLocked }) {
  useEffect(() => {
    if (party?.teamsLocked) onTeamsLocked?.()
  }, [party?.teamsLocked]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!party) {
    return (
      <div className="party-team-setup">
        <p style={{ color: 'var(--text-muted)' }}>Loading...</p>
      </div>
    )
  }

  const teams = party.teams ? Object.entries(party.teams) : []
  const players = party.players ?? {}

  return (
    <div className="party-team-setup">
      <h2 className="party-team-setup__title"><IconClapper size={20} style={{ verticalAlign: 'middle' }} /> Team Setup</h2>
      <p style={{ color: 'var(--text-muted)', textAlign: 'center' }}>
        Director is organizing teams
      </p>

      {!party.teamCount && (
        <p className="party-team-setup__waiting">
          Waiting for Director to set team count...
        </p>
      )}

      {party.teamCount && (
        <div className="party-teams-grid">
          {teams.map(([teamId, team], idx) => {
            const color = TEAM_COLORS[idx % TEAM_COLORS.length]
            const members = Object.entries(players).filter(
              ([, p]) => p.teamId === teamId
            )
            return (
              <div
                key={teamId}
                className="party-team-col"
                style={{ borderColor: color }}
              >
                <span className="party-team-col__name" style={{ color }}>
                  {team.name || `Team ${idx + 1}`}
                </span>
                <div className="party-team-col__members">
                  {members.length === 0 && (
                    <span style={{ color: 'var(--text-muted)', fontSize: '0.8rem' }}>
                      Empty
                    </span>
                  )}
                  {members.map(([uid, p]) => (
                    <div key={uid} className="party-team-member">
                      <div className="party-team-member__avatar">
                        {p.avatar
                          ? <img src={p.avatar} alt={p.username || 'Player'} />
                          : <span>{(p.username || 'G').charAt(0).toUpperCase()}</span>
                        }
                      </div>
                      <span>{p.username || 'Guest'}</span>
                    </div>
                  ))}
                </div>
              </div>
            )
          })}

          {/* Render empty team placeholders if teams not yet populated */}
          {teams.length === 0 && party.teamCount > 0 &&
            Array.from({ length: party.teamCount }).map((_, idx) => {
              const color = TEAM_COLORS[idx % TEAM_COLORS.length]
              return (
                <div
                  key={idx}
                  className="party-team-col"
                  style={{ borderColor: color }}
                >
                  <span className="party-team-col__name" style={{ color }}>
                    Team {idx + 1}
                  </span>
                  <div className="party-team-col__members">
                    <span style={{ color: 'var(--text-muted)', fontSize: '0.8rem' }}>
                      Empty
                    </span>
                  </div>
                </div>
              )
            })
          }
        </div>
      )}

      {party.teamsLocked && (
        <p style={{ color: 'var(--accent-gold)', fontWeight: 700 }}>
          Teams locked! Get ready...
        </p>
      )}
    </div>
  )
}
